import { TOKEN_KEY } from "./api";

export function decodeToken(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload;
    } catch {
        return null;
    }
}

export function getUserRole() {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    const p = decodeToken(token);
    if (!p) return null;
    if (p.exp && p.exp * 1000 < Date.now()) return null;
    return p.role || null;
}

export function isAuthed() {
    return !!getUserRole();
}
